import {createFileRoute} from '@tanstack/react-router';
import SubscriptionPage from '@features/subscription/page';
import {z} from 'zod';

export const Route = createFileRoute('/subscription/')({
  component: SubscriptionPage,
  validateSearch(search) {
    return z
      .object({
        newUser: z.boolean().optional(),
        source: z.string().optional(),
        redirectFlow: z.string().optional(),
      })
      .parse(search);
  },
});
